(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-cv-interactive-word]').forEach(word => {
    if (word.dataset.initialized) return;
    word.dataset.initialized = 'true';
    const letters = word.querySelectorAll(':scope > span > span');
    const play = () => {
      if (reducedMotion.matches) return;
      letters.forEach((letter, index) => {
        letter.getAnimations().forEach(animation => animation.cancel());
        letter.animate([
          { transform: 'translateY(0)' },
          { transform: 'translateY(-3px)', offset: .38 },
          { transform: 'translateY(0)' }
        ], { duration: 440, delay: index * 22, easing: 'cubic-bezier(.2,.7,.3,1)' });
      });
    };
    word.addEventListener('pointerenter', play);
    word.addEventListener('focus', play);
    word.addEventListener('click', play);
  });
})();
